import {
  createStore,
  combineReducers,
  applyMiddleware
} from 'redux';
import {
  combineForms,
  createForms
} from 'react-redux-form';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import results from './reducers/results';
import tickers from './reducers/tickers';
import { BT_START } from './config/constants';

const initialState = {
  startingAmount: 10000,
  startingDate: BT_START,
  stockAllocation: 60,
  bitcoinPercentage: 5,
  withRebalancing: true,
};

const store = createStore(
  combineReducers({
    results,
    tickers,
    ...createForms({
      input: initialState,
    })
  }),
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

export default store;


// WEBPACK FOOTER //
// ./src/store.js